module.exports = __webpack_public_path__ + "img/iconGaoJingChuLi.c2b4f06d.svg";